import React from 'react';
import './PanelDropdown.css';

const PanelDropdown = ({ disabled = false, disabledTooltip, label, options = [], onChange, value }) => (
  <>
    <label className="panel-dropdown-label">{label}</label>
    <select
      className="panel-dropdown-select"
      onChange={onChange}
      value={value ?? ''}
      disabled={disabled}
      title={disabled && disabledTooltip ? disabledTooltip : undefined}
    >
      {options.map((opt, i) => (
        <option key={i} value={opt.value ?? opt}>{opt.label ?? opt}</option>
      ))}
    </select>
    {disabled && disabledTooltip && (
      <span className="panel-dropdown-disabled-reason">{disabledTooltip}</span>
    )}
  </>
);

export { PanelDropdown };
